import Icon from '../components/Icon.vue'

Icon.register({
  'map-pin': {
    width: 288,
    height: 512,
    paths: [
      {
        d: 'M112 316.9V473.6L134 506.6C138.8 513.8 149.2 513.8 154 506.6L176 473.6V316.9C165.6 318.9 154.9 320 144 320S122.4 318.9 112 316.9zM144 0C64.5 0 0 64.5 0 144S64.5 288 144 288 288 223.5 288 144 223.5 0 144 0zM144 76C106.5 76 76 106.5 76 144 76 150.6 70.6 156 64 156S52 150.6 52 144C52 93.3 93.3 52 144 52 150.6 52 156 57.4 156 64S150.6 76 144 76z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/map-pin.js
// module id = oKy+
// module chunks = 144